import "./CareersPage.css";
import React, { useState } from "react";
import team1 from "./media/prime10.jpg";
import team2 from "./media/operation.jpg";
import team3 from "./media/ps3.JPG";
import team4 from "./media/prime9.jpg";
import team5 from "./media/ps4.JPG";
import Navbar from "./Navbar";
import HoverRevealSection from "./HoverRevealSection";
import FindRoles from "./FindRoles";
import HireForm from "./HireForm";

export default function CareersPage() {
    const scrollLife = (direction) => {
  const container = document.getElementById("lifeScroll");
  const cardWidth = container.querySelector(".life-card").offsetWidth + 30; // card + gap

  container.scrollBy({
    left: direction * cardWidth,
    behavior: "smooth"
  });
   
};

  return (
   
    <div className="careers-page">
        <Navbar />
      {/* HERO */}
      <section className="careers-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h4 className="hero-eyebrow">PRIMEMAX CAREERS</h4>
          <h4 className="hero-title">JOIN OUR TEAM</h4>
          <p className="hero-sub">Help us redefine modern dentistry.</p>
          {/* <button className="hero-btn">View Open Roles</button> */}
        </div>
      </section>

      {/* STORY SECTION */}
      <section className="careers-story">
        <h2>Changing Smiles. Changing Lives.</h2>
        <p>
Ready for a rewarding career where you can truly impact patient well-being? At [Clinic Name], we are more than just a dental practice—we are a dedicated family committed to providing exceptional, compassionate care and fostering a positive, collaborative work environment. We believe in investing in our team, offering continuous education, mentorship, and opportunities for professional growth.

We are seeking enthusiastic and skilled professionals across all roles, including clinical staff, hygienists, and administrative support, who share our passion for excellence. If you are driven by quality, empathy, and innovation, we invite you to explore a career with us. Join our journey in shaping healthier, happier smiles every day!
Ready for a rewarding career where you can truly impact patient well-being? At [Clinic Name], we are more than just a dental practice—we are a dedicated family committed to providing exceptional, compassionate care and fostering a positive, collaborative work environment. We believe in investing in our team, offering continuous education, mentorship, and opportunities for professional growth.

We are seeking enthusiastic and skilled professionals across all roles, including clinical staff, hygienists, and administrative support, who share our passion for excellence. If you are driven by quality, empathy, and innovation, we invite you to explore a career with us. Join our journey in shaping healthier, happier smiles every day!
        </p>
      </section>

      {/* SPLIT SECTION */}
      <section className="careers-split">
        <div className="split-left"><img src={team1} alt="Team" /></div>

        <div className="split-right">
          <h2>Work With Purpose</h2>
          <p>
            Whether you’re a clinician or a creative mind, PrimeMax gives
            you an environment to grow, innovate, and genuinely help people.
          </p>

          <ul>
            <li>Patient-first culture</li>
            <li>Modern equipment & digital workflow</li>
            <li>Growth-driven team</li>
            <li>Work that makes a real difference</li>
          </ul>
        </div>
      </section>
       <section className="careers-split">
       

        <div className="split-right">
          <h2>Innovate & Elevate</h2>
          <p>
           We are committed to being at the forefront of dental excellence. PrimeMax provides the tools and freedom you need to grow your expertise and deliver the best possible care.
          </p>

          <ul>
            <li>Cutting-Edge Technology: Work with the latest equipment and techniques</li>
            <li>Continuous Education: Generous allowances for professional development</li>
            <li>Autonomy in Practice: Trust and freedom to excel in your role.</li>
            <li>Shape the Future of Dentistry: Contribute to a forward-thinking practice.</li>
          </ul>
        </div>
         <div className="split-left"><img src={team2} alt="Team" /></div>
      </section>
      <section className="careers-split">
        <div className="split-left"><img src={team3} alt="Team" /></div>

        <div className="split-right">
          <h2>Collaboration & Support</h2>
          <p>
At PrimeMax, we succeed together. We foster a supportive, high-trust environment where every team member is valued and heard.
          </p>

          <ul>
            <li>Mentorship Programs: Learn from the best and elevate your skills.</li>
            <li>Team-Based Approach: Shared success in every smile we create.</li>
            <li>Open Communication: Your ideas drive our innovation</li>
            <li>Focus on Well-being: A balanced life is a productive life</li>
          </ul>
        </div>
      </section>
{/* LIFE AT PrimeMax — HORIZONTAL SCROLL */}
<section className="life-section">
  <h2 className="life-title">LIFE AT PRIMEMAX</h2>

  <div className="life-wrapper">

    {/* LEFT ARROW */}
    <button className="scroll-btn left" onClick={() => scrollLife(-1)}>‹</button>

    {/* SCROLL AREA */}
    <div className="life-scroll" id="lifeScroll">
      {/** SAME CARDS AS BEFORE **/}

      {/* CARD 1 */}
      <div className="life-card">
        <img src={team1} className="life-img" alt="" />
        <div className="life-card-content">
          <h3>Innovation in Dentistry 2025</h3>
          <h4>Digital Forward</h4>
          <p>Leading with advanced scanners, lasers, and workflows.</p>
          {/* <span className="life-arrow">→</span> */}
        </div>
      </div>

      {/* CARD 2 */}
      <div className="life-card">
        <img src={team4} className="life-img" alt="" />
        <div className="life-card-content">
          <h3>Top Workplace Recognition</h3>
          <h4>Built In 2025</h4>
          <p>A culture built on teamwork and innovation.</p>
          {/* <span className="life-arrow">→</span> */}
        </div>
      </div>

      {/* CARD 3 */}
      <div className="life-card">
        <img src={team5} className="life-img" alt="" />
        <div className="life-card-content">
          <h3>Career Growth</h3>
          <h4>Mentorship & Leadership</h4>
          <p>Grow with hands-on training and leadership.</p>
          {/* <span className="life-arrow">→</span> */}
        </div>
      </div>

      

     
    </div>

    {/* RIGHT ARROW */}
    <button className="scroll-btn right" onClick={() => scrollLife(1)}>›</button>
  </div>
</section>

{/* <HoverRevealSection /> */}
<FindRoles />
<HireForm />


      {/* FINAL CALL TO ACTION */}
      <section className="careers-final">
        <h2>Ready to build the future of Dentistry?</h2>
        {/* <button className="final-btn">Explore Careers</button> */}
      </section>

    </div>
  );
}
